<script setup>
/**
 * 手写面板
 */
import { ref, onMounted, nextTick } from 'vue'
import { get } from 'lodash-es'
import api from '@/api'
import { DrawingBoard } from '@/utils/hand-write'

const emits = defineEmits(['select-character', 'remove-back'])
const results = ref([])
let drawingBoard = null

// 查找汉字
const lookup = async () => {
  if (!drawingBoard) return
  const strokes = drawingBoard.cloneStrokes()
  const data = strokes
    .map((stroke) => {
      return stroke.map((strokePoint) => strokePoint.join(',')).join(',')
    })
    .join(',-1,0,')

  if (data) {
    const res = await api.handWord.handWriteRecognize({
      data: data + ',-1,0,'
    })

    const result = get(res, 'data.result', '')
      .split(',')
      .filter(Boolean)
      .map((unicode) => String.fromCodePoint(unicode))

    results.value = result.slice(0, 8)
  }
}

const drawingBoardClass = ref('drawingBoard')
const initDrawingBoard = () => {
  if (!window.drawingBoardNum) {
    window.drawingBoardNum = 1
  } else {
    window.drawingBoardNum++
  }
  drawingBoardClass.value = `drawingBoard-${window.drawingBoardNum}`

  // 初始化画板
  nextTick(() => {
    // eslint-disable-next-line no-undef
    drawingBoard = DrawingBoard($(`.${drawingBoardClass.value}`).first(), lookup)
  })
}

// 处理清除
const handleClear = () => {
  if (!drawingBoard) return
  drawingBoard.clearCanvas()
  drawingBoard.redraw()
  results.value = []
  lookup()
}

onMounted(() => {
  // 初始化 HanziLookup
  initDrawingBoard()
})

function selectCharacter(character) {
  handleClear()
  emits('select-character', character)
}

function inputVal(key) {
  emits('select-character', key)
}

function removeBack() {
  emits('remove-back')
}
</script>

<template>
  <div class="panel-handwrite">
    <div class="panel-left">
      <div v-if="results.length" class="results">
        <div
          v-for="result in results"
          :key="result"
          class="result-item"
          @click="selectCharacter(result)"
        >
          {{ result }}
        </div>
      </div>
      <div v-else class="hand-write-tip">请在下方手写板书写</div>
      <div :class="drawingBoardClass"></div>
    </div>
    <div class="panel-right">
      <div class="keyboard-row">
        <div class="keyboard-item span-2" @click="handleClear">重写</div>
        <div class="keyboard-item" @click="inputVal('1')">1</div>
        <div class="keyboard-item" @click="inputVal('6')">6</div>
      </div>
      <div class="keyboard-row">
        <div class="keyboard-item span-2" @click="inputVal('，')">，</div>
        <div class="keyboard-item" @click="inputVal('2')">2</div>
        <div class="keyboard-item" @click="inputVal('7')">7</div>
      </div>
      <div class="keyboard-row">
        <div class="keyboard-item span-2" @click="inputVal('。')">。</div>
        <div class="keyboard-item" @click="inputVal('3')">3</div>
        <div class="keyboard-item" @click="inputVal('8')">8</div>
      </div>
      <div class="keyboard-row">
        <div class="keyboard-item span-2" @click="inputVal('、')">、</div>
        <div class="keyboard-item" @click="inputVal('4')">4</div>
        <div class="keyboard-item" @click="inputVal('9')">9</div>
      </div>
      <div class="keyboard-row">
        <div class="keyboard-item span-2" @click="removeBack">回退</div>
        <div class="keyboard-item" @click="inputVal('5')">5</div>
        <div class="keyboard-item" @click="inputVal('0')">0</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
/* 画布背景色 */
.stroke-input-canvas {
  background-color: #413e6d;
  border-radius: $radius;
  display: block;
}
</style>

<style lang="scss" scoped>
.panel-handwrite {
  display: flex;

  .panel-left {
    .results {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
      height: 40px;

      .result-item {
        text-align: center;
        width: 40px;
        height: 40px;
        line-height: 40px;
        border: 1px solid rgba(255, 255, 255, 0.25);
        border-radius: $radius;
        background-color: #0f0c3a;

        &:active {
          background: #eee;
          color: #333333;
        }

        & + .result-item {
          margin-left: 10px;
        }
      }
    }

    .hand-write-tip {
      height: 50px;
      line-height: 50px;
    }
  }

  .panel-right {
    padding-top: 50px;
    margin-left: 20px;

    .keyboard-row {
      display: flex;

      & + .keyboard-row {
        margin-top: 16px;
      }

      .keyboard-item {
        width: 63px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        border: 1px solid rgba(255, 255, 255, 0.25);
        border-radius: $radius;
        background-color: #0f0c3a;
        font-size: 20px;

        &.span-2 {
          width: 84px;
        }

        &:active {
          background: #eee;
          color: #333333;
        }

        & + .keyboard-item {
          margin-left: 15px;
        }
      }
    }
  }
}
</style>
